

// Values

const AMOUNT_OF_DIGITAL_CURRENCY_SENT_VALUE = 'AMOUNT_OF_DIGITAL_CURRENCY_SENT_VALUE'
const AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_VALUE = 'AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_VALUE'
const TOTAL_DIGITAL_CURRENCY_BALANCE_VALUE = 'TOTAL_DIGITAL_CURRENCY_BALANCE_VALUE'

const NUMBER_OF_TRANSACTIONS_CREATED_VALUE = 'NUMBER_OF_TRANSACTIONS_CREATED_VALUE'
const NUMBER_OF_TRANSACTIONS_RECEIVED_VALUE = 'NUMBER_OF_TRANSACTIONS_RECEIVED_VALUE'
const NUMBER_OF_TRANSACTIONS_DELETED_VALUE = 'NUMBER_OF_TRANSACTIONS_DELETED_VALUE'
const TOTAL_ACTIVE_TRANSACTIONS_VALUE = 'TOTAL_ACTIVE_TRANSACTIONS_VALUE'

const NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_VALUE = 'NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_VALUE'
const NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_VALUE = 'NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_VALUE'
const NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_VALUE = 'NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_VALUE'
const TOTAL_ACTIVE_RECURRING_TRANSACTIONS_VALUE = 'TOTAL_ACTIVE_RECURRING_TRANSACTIONS_VALUE'

const TOTAL_RECURRING_TRANSACTION_INCOME_VALUE = 'TOTAL_RECURRING_TRANSACTION_INCOME_VALUE'
const TOTAL_RECURRING_TRANSACTION_EXPENDITURE_VALUE = 'TOTAL_RECURRING_TRANSACTION_EXPENDITURE_VALUE'

const NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_VALUE = 'NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_VALUE'
const NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_VALUE = 'NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_VALUE'


// Data Tables

const CREATED_TRANSACTION_DATA_TABLE = 'CREATED_TRANSACTION_DATA_TABLE'
const RECEIVED_TRANSACTION_DATA_TABLE = 'RECEIVED_TRANSACTION_DATA_TABLE'
const RECEIVED_RECURRING_TRANSACTION_DATA_TABLE = 'RECEIVED_RECURRING_TRANSACTION_DATA_TABLE'

// Bar Graphs

const AMOUNT_OF_DIGITAL_CURRENCY_SENT_GRAPH = 'AMOUNT_OF_DIGITAL_CURRENCY_SENT_GRAPH'
const AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_GRAPH = 'AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_GRAPH'
const TOTAL_DIGITAL_CURRENCY_BALANCE_GRAPH = 'TOTAL_DIGITAL_CURRENCY_BALANCE_GRAPH'

const NUMBER_OF_TRANSACTIONS_CREATED_GRAPH = 'NUMBER_OF_TRANSACTIONS_CREATED_GRAPH'
const NUMBER_OF_TRANSACTIONS_RECEIVED_GRAPH = 'NUMBER_OF_TRANSACTIONS_RECEIVED_GRAPH'
const NUMBER_OF_TRANSACTIONS_DELETED_GRAPH = 'NUMBER_OF_TRANSACTIONS_DELETED_GRAPH'
const TOTAL_ACTIVE_TRANSACTIONS_GRAPH = 'TOTAL_ACTIVE_TRANSACTIONS_GRAPH'

const NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_GRAPH = 'NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_GRAPH'
const NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_GRAPH = 'NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_GRAPH'
const NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_GRAPH = 'NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_GRAPH'
const TOTAL_ACTIVE_RECURRING_TRANSACTIONS_GRAPH = 'TOTAL_ACTIVE_RECURRING_TRANSACTIONS_GRAPH'

const TOTAL_RECURRING_TRANSACTION_INCOME_GRAPH = 'TOTAL_RECURRING_TRANSACTION_INCOME_GRAPH'
const TOTAL_RECURRING_TRANSACTION_EXPENDITURE_GRAPH = 'TOTAL_RECURRING_TRANSACTION_EXPENDITURE_GRAPH'

const NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_GRAPH = 'NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_GRAPH'
const NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_GRAPH = 'NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_GRAPH'


export {
  // Values
  AMOUNT_OF_DIGITAL_CURRENCY_SENT_VALUE,
  AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_VALUE,
  TOTAL_DIGITAL_CURRENCY_BALANCE_VALUE,

  NUMBER_OF_TRANSACTIONS_CREATED_VALUE,
  NUMBER_OF_TRANSACTIONS_RECEIVED_VALUE,
  NUMBER_OF_TRANSACTIONS_DELETED_VALUE,
  TOTAL_ACTIVE_TRANSACTIONS_VALUE,

  NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_VALUE,
  NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_VALUE,
  NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_VALUE,
  TOTAL_ACTIVE_RECURRING_TRANSACTIONS_VALUE,

  TOTAL_RECURRING_TRANSACTION_INCOME_VALUE,
  TOTAL_RECURRING_TRANSACTION_EXPENDITURE_VALUE,

  NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_VALUE,
  NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_VALUE,

  // Data Tables

  CREATED_TRANSACTION_DATA_TABLE,
  RECEIVED_TRANSACTION_DATA_TABLE,
  RECEIVED_RECURRING_TRANSACTION_DATA_TABLE,

  // Bar Graphs

  AMOUNT_OF_DIGITAL_CURRENCY_SENT_GRAPH,
  AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_GRAPH,
  TOTAL_DIGITAL_CURRENCY_BALANCE_GRAPH,

  NUMBER_OF_TRANSACTIONS_CREATED_GRAPH,
  NUMBER_OF_TRANSACTIONS_RECEIVED_GRAPH,
  NUMBER_OF_TRANSACTIONS_DELETED_GRAPH,
  TOTAL_ACTIVE_TRANSACTIONS_GRAPH,

  NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_GRAPH,
  NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_GRAPH,
  NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_GRAPH,
  TOTAL_ACTIVE_RECURRING_TRANSACTIONS_GRAPH,

  TOTAL_RECURRING_TRANSACTION_INCOME_GRAPH,
  TOTAL_RECURRING_TRANSACTION_EXPENDITURE_GRAPH,

  NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_GRAPH,
  NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_GRAPH
}





